import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { HINWEIS_AN_HA_PLACEHOLDER_TEXT, PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import {
	AbschlussSeiteHinweisFeldBox,
	AbschlussSeiteHochladeFeldBox,
	FinaleSchritteInfoBoxAbschlussbericht,
} from '../../../../antrag-components/AbschlussSeiteBox';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const BerichtAbschlussStartUpProjekte: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Abschluss" description={PLATZHALTER_TEXT} />

			<FinaleSchritteInfoBoxAbschlussbericht />

			<AbschlussSeiteHochladeFeldBox>
				<CreateForm formStruc={formStrucUpload()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
			</AbschlussSeiteHochladeFeldBox>

			<AbschlussSeiteHinweisFeldBox>
				<CreateForm formStruc={formStrucHinweis()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
			</AbschlussSeiteHinweisFeldBox>
		</>
	);
};

export default BerichtAbschlussStartUpProjekte;

const formStrucUpload = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ ...P.Allgemein_Eingereichter_Abschlussbericht, hideLabel: true }],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucHinweis = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ ...P.Allgemein_Hinweise_An_Die_HA, placeholder: HINWEIS_AN_HA_PLACEHOLDER_TEXT }],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};
export const getFormStrucBerichtAbschlussStartUpProjekte = () => {
	return concat(formStrucUpload());
};
